import { render } from "./h5.vue?vue&type=template&id=2c3e8e5c"
import script from "./h5.vue?vue&type=script&lang=js"
export * from "./h5.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Layout/h5.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c3e8e5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c3e8e5c', __exports__)) {
    api.reload('2c3e8e5c', __exports__)
  }
  
  module.hot.accept("./h5.vue?vue&type=template&id=2c3e8e5c", () => {
    api.rerender('2c3e8e5c', render)
  })

}


export default __exports__